import { AdditionalCover, MedicalDeclaration, Payment, SchemeChoice, TripDetails, Complete } from './scenes';
import { IChannel } from '../../data/api/models';

const componentKeyMap = {
  tripDetails: TripDetails,
  medicalDeclaration: MedicalDeclaration,
  additionalCover: AdditionalCover,
  schemeChoice: SchemeChoice,
  payment: Payment,
  complete: Complete,
};

function mapComponentsFromKey(step) {
  return {
    ...step,
    component: componentKeyMap[ step.key ],
  };
}

export default (channel: IChannel) => {
  const defaultSteps = [
    {
      title: 'Trip Details',
      key: 'tripDetails',
      route: '/',
      calculatePremium: false,
    },
    {
      title: 'Medical Declaration',
      key: 'medicalDeclaration',
      route: '/medical-declaration',
      calculatePremium: false,
    },
    {
      title: 'Additional Cover',
      key: 'additionalCover',
      route: '/additional-cover',
      calculatePremium: false,
    },
    {
      title: 'Scheme Choice',
      key: 'schemeChoice',
      route: '/scheme-choice',
      calculatePremium: true,
    },
    {
      title: 'Payment',
      key: 'payment',
      route: '/payment',
      calculatePremium: true,
    },
    {
      title: 'Complete',
      key: 'complete',
      route: '/complete',
      calculatePremium: true,
    },
  ];

  const config = channel.steps ? channel.steps : defaultSteps;

  return config.map(mapComponentsFromKey);
};
